module.exports = __webpack_public_path__ + "b824e64463bf3c9fbeb34ebe3acd22fc.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/beard-yellow.png
// module id = 2308
// module chunks = 0